import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { checkStatus, setLoader } from '../../../util/util';
import Select from 'react-select';
import map from 'lodash/map';
import { AlertBar, AlertConfirm } from '../../Modals/AlertBar';
import DateTimeRange from '../UserControl/DateTimeRange/DateTimeRange';
import moment from 'moment';
import ReactToExcel from 'react-html-table-to-excel';
import ModalReportSummaryByGroup from '../Report/ModalReportSummaryByGroup';
import MapAlertSummaryReport from '../../components/Report/MapAlertSummaryReport';
import html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf'
import { TimePicker } from 'antd';
import { Alert } from '../../Modals/AlertBar';


const Canvas2Image = window.Canvas2Image;
let startHistoryDate = null;
let endHistoryDate = null;
let tagsDevice = [];


class ReportRFID extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectDateRange: {
                startDate: null,
                endDate: null
            },
            isClickLoadReport: '',
            reportType: '',
            selectedReportType: '',
            totalPage: 0,
            reportList: [],
            reportSummaryList: {},
            deviceGroupList: [],

            selectedGroup: '',
            startDate: moment().format('DD-MM-YYYY'),
            endDate: moment().format('DD-MM-YYYY'),
            is_speed_over: false,
            speed_over_interval: 0,

            criteriaSearch: {
                device_group: '',
                start_date: moment().format('DD-MM-YYYY'),
                end_date: moment().format('DD-MM-YYYY'),
                is_speed_over: false,
                speed_over_interval: 0,
                stop_interval: 10
            },

            speedOverSummaryList: [],
            showModalReport: false,

            speedMaxLat: 0,
            speedMaxLong: 0,
            isFullScreen: false,
            isDownLoadExcel: false,
            stopInterval: 10,
            isDownLoadPdf: false,

            selectHistoryDateRange: {
                startDate: this.getCurrentDate(new Date()),
                endDate: this.getCurrentDate(new Date()),
                startTimeHistory: "00:00",
                endTimeHistory: "23:50"
            },

            deviceAndGroupList: [],
            selectedDevice: '',
            rfidList: [],
            isElapseTimeOver: 0,
            isElapseTimeFlag: false,
            isNotScan: false,
            isClickRowToShowLocation: false,

            device_no: '',
            symbolId: '',
            symbolColor: '',
            lat: 0,
            long: 0,
            placeName: '',
            isMobile: false
        }
    }

    componentWillMount() {
        this.setState({ isMobile: window.innerWidth < 400 });
    }

    componentDidMount() {
        this.getDeviceAndGroupList();
        // this.getReportRFID();
        this.getDeviceGroupList();
    }

    componentWillUnmount() {
        this.setState({ isDownLoadPdf: false });
    }
    getDeviceGroupList = () => {
        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/admin/getDeviceGroupList`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "user_id": user_id,
                "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({})
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        name: obj.name,
                    });
                });
                this.setState({
                    deviceGroupList: objList
                });
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    btnSearchHistoryClick = (e) => {

        if(e === undefined){
            return;
        }
        console.log("btnSearchHistoryClick", this.getCurrentDate(startHistoryDate), this.state.selectHistoryDateRange.startTimeHistory, this.state.selectHistoryDateRange.endTimeHistory, tagsDevice);
        if (startHistoryDate == null || endHistoryDate == null || this.state.selectHistoryDateRange.startTimeHistory == "" || this.state.selectHistoryDateRange.endTimeHistory == "")
            Alert("กรุณาใส่ข้อมูล", "วัน เวลา ที่ต้องการดูย้อนหลัง");
        else {
            let stime = this.state.selectHistoryDateRange.startTimeHistory;
            let etime = this.state.selectHistoryDateRange.endTimeHistory;
            let start = this.getCurrentDate(startHistoryDate);
            let end = this.getCurrentDate(endHistoryDate)
            let dd = this.getCurrentDate(startHistoryDate).split("-")[0];
            let mm = this.getCurrentDate(startHistoryDate).split("-")[1];
            let yyyy = this.getCurrentDate(startHistoryDate).split("-")[2];
            start = dd + "-" + mm + "-" + yyyy;
            dd = this.getCurrentDate(endHistoryDate).split("-")[0];
            mm = this.getCurrentDate(endHistoryDate).split("-")[1];
            yyyy = this.getCurrentDate(endHistoryDate).split("-")[2];
            end = dd + "-" + mm + "-" + yyyy;


            this.getReportRFID(stime, start, etime, end, tagsDevice, this.state.currentPage, this.state.currentPageSize);
            // this.getReportSummaryByDevice(stime,start,etime,end,tagsDevice);
            // this.mapTrackingPoi.current.setMapTrackingHistory(stime,start,etime,end,tagsHistory);
            console.log(stime, start, etime, end, tagsDevice)
        }

    }

    getReportRFID = (stime, start, etime, end, tagsDevice, page, pageSize) => {
        const { user_id, user_name, token } = this.props;
        const { criteriaSearch } = this.state;

        let start_date = start + " " + stime;
        let end_date = end + " " + etime;
        let devices = [];
        if (this.state.selectedDevice !== "" && this.state.selectedDevice !== undefined)
            devices = [this.state.selectedDevice];

        console.log(this.state.selectedDevice)
        console.log(start_date)
        console.log(end_date)
        setLoader(true)
        fetch(`http://203.150.199.244/api/report/getReportRFID/${1}/${9999}`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            // body: JSON.stringify({ criteriaSearch })
            body: JSON.stringify({

                "devices": devices,
                "start_date": start_date,
                "end_date": end_date,
                // "start_date" : '15-01-2019 23:00',
                // "end_date": '18-01-2019 23:00',

                "elapse_time_over": this.state.isElapseTimeOver,
                "is_not_scan": this.state.isNotScan
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log(data.RESULT_DATA)

                if (!data.RESULT_DATA && data.RESULT_DATA.length == 0)
                    return;

                let dataList = [];
                let datas = {};
                let details = {};
                let summary = {};
                let deviceNo = {};

                // data.RESULT_DATA.map((data) => {

                //     if(data.details.length > 0)
                //         deviceNo = {device_no:data.details[0].device_no};

                //     details = data.details;
                //     summary = data.summary;
                //     datas = {deviceNo,details,summary};
                //     dataList.push(datas);
                // })
                console.log(data.RESULT_DATA)
                this.setState({
                    rfidList: data.RESULT_DATA,
                });
                setLoader(false)
            })
            .catch(function (err) {
                console.log('err:', err);
                setLoader(false)
                // POST failed...
            });
            
    }

    setRangeDate(sDate, eDate) {
        let startDate = sDate;
        let endDate = eDate;
        if (sDate && eDate && sDate !== null && eDate !== null) {
            startDate = sDate.toObject();
            endDate = eDate.toObject();
            this.setState({
                startDate: moment(startDate).format('DD-MM-YYYY'),
                endDate: moment(endDate).format('DD-MM-YYYY')
            })
        }
    }

    handleClick = (e) => {
        const { isClickLoadReport } = this.state;
        if (isClickLoadReport === 'show') {
            this.setState({ isClickLoadReport: '' });
        } else {
            this.setState({ isClickLoadReport: 'show' });
        }
    }

    handleSubmitSearchReport = () => {
        const {
            startDate,
            endDate,
            selectedGroup,
            speed_over_interval,
            is_speed_over,
            stopInterval
        } = this.state;
        this.setState({
            criteriaSearch: {
                ...this.state.criteriaSearch,
                device_group: selectedGroup.label || '',
                start_date: startDate,
                end_date: endDate,
                is_speed_over,
                speed_over_interval,
                stop_interval: stopInterval
            }
        }, () => this.getReportSummaryByGroup());
    }

    onClickSpeedOverTimes = (device_id, device_no, key) => {
        const { user_id, user_name, token } = this.props;
        const { startDate, endDate, reportList } = this.state;
        this.setState({
            symbolId: reportList[key].symbol_id,
            symbolColor: reportList[key].symbol_color
        });
        fetch(`http://203.150.199.244/api/report/getSpeedOverSummary`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "user_id": user_id,
                "user_name": user_name,
                "token": token
            },
            // body: JSON.stringify({ criteriaSearch })
            body: JSON.stringify({
                "device_id": device_id,
                "start_date": startDate,
                "end_date": endDate
            })
        })
            .then(response => { return checkStatus(response) })
            .then((data) => {
                let objList = [];
                data.RESULT_DATA.map((obj, key) => {
                    objList.push({
                        distance: obj.distance,
                        elapse_time_s: obj.elapse_time_s,
                        end_at_latitude: obj.end_at_latitude,
                        end_at_longitude: obj.end_at_longitude,
                        end_at_place: obj.end_at_place,
                        end_dtm: obj.end_dtm,
                        max_speed: obj.max_speed,
                        start_at_latitude: obj.start_at_latitude,
                        start_at_longitude: obj.start_at_longitude,
                        start_at_place: obj.start_at_place,
                        start_dtm: obj.start_dtm
                    });
                });
                this.setState({ speedOverSummaryList: objList, showModalReport: true, device_no });
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onClickMaxSpeed = (lat, long, device_no) => {
        const { symbolId, symbolColor } = this.state;
        this.setState({ isShowMaxSpeedLocation: true, speedMaxLat: lat, speedMaxLong: long });
    }

    handleFullScreenToggle = () => {
        const { isFullScreen } = this.state;
        if (!isFullScreen) {
            this.setState({ isFullScreen: true });
        } else {
            this.setState({ isFullScreen: false });
        }
    }

    setRangeDate(sDate, eDate) {
        let startDate = sDate;
        let endDate = eDate;
        if (sDate && eDate && sDate !== null && eDate !== null) {
            startDate = sDate.toObject();
            endDate = eDate.toObject();
            this.setState({
                startDate: moment(startDate).format('DD-MM-YYYY'),
                endDate: moment(endDate).format('DD-MM-YYYY')
            })
        }
    }


    getCurrentDate(today) {
        //let today = new Date();
        if (today == null)
            return null;
        let dd = !today.date ? today.getDate() : today.date;
        let mm = today.months == undefined ? today.getMonth() + 1 : today.months + 1; //January is 0! today
        let yyyy = !today.years ? today.getFullYear() : today.years;
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        return (dd + '-' + mm + '-' + yyyy);
    }

    handleStartTimeHistoryChange(value) {
        this.state.selectHistoryDateRange.startTimeHistory = value.format('HH') + ":" + value.format('mm');
    }
    handleEndTimeHistoryChange(value) {
        this.state.selectHistoryDateRange.endTimeHistory = value.format('HH') + ":" + value.format('mm');
    }
    setRangeDate(sDate, eDate) {
        startHistoryDate = sDate;
        endHistoryDate = eDate;
        if (sDate && eDate && sDate != null && eDate != null) {
            startHistoryDate = sDate.toObject();
            endHistoryDate = eDate.toObject();
        }
        console.log("setRangeDate", startHistoryDate, endHistoryDate);
    }

    getDeviceAndGroupList() {

        const { user_id, user_name, token } = this.props;
        fetch("http://203.150.199.244/api/admin/getDeviceAndGroupList", {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                // "filter":name
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log(data)
                this.setState({
                    deviceAndGroupList: data.RESULT_DATA
                })

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    getReport() {
        let obj = this.state.rfidList;
        let date = `ระหว่างวันที่ ${this.getCurrentDate(startHistoryDate) + "," + this.state.selectHistoryDateRange.startTimeHistory} ถึง ${this.getCurrentDate(endHistoryDate) + "," + this.state.selectHistoryDateRange.endTimeHistory}`;
        const { user_id, user_name, token } = this.props;
        fetch(`http://203.150.199.244/api/report/exportPdf/10`, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                //    "user_id": user_id,
                //    "user_name": user_name,
                "token": token

            },
            body: JSON.stringify({
                "title": date,
                "result_data": obj
            })
        })
            .then(response => { return checkStatus(response) })
            .then(data => {
                console.log(data)
                // setTimeout(function(){ document.location.href = `http://203.150.199.244/api/report/download/${data.file_name}`; }, 1000);
                document.location.href = `http://203.150.199.244/api/report/download/${data.file_name}`;

            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    downLoadPdf = () => {
        this.setState({ isDownLoadPdf: true });
        html2canvas(document.querySelector("#printableTable"), {
            scale: 1.3
        }).then(canvas => {
            const imageData = canvas.toDataURL("image/png");
            const image = new Image();

            image.onload = function () {
                const doc = new jsPDF('l', 'mm');
                doc.addImage(imageData, 'PNG', 12, 10);
                let croppingYPosition = 1095;
                let count = (canvas.height) / 1095;
                for (let i = 1; i < count; i++) {
                    doc.addPage();
                    const sourceX = 0;
                    const sourceY = croppingYPosition;
                    const sourceWidth = canvas.width;
                    const sourceHeight = 1095;
                    const destWidth = sourceWidth;
                    const destHeight = sourceHeight;
                    const destX = 0;
                    const destY = 0;
                    const canvas1 = document.createElement('canvas');
                    canvas1.setAttribute('height', destHeight);
                    canvas1.setAttribute('width', destWidth);
                    const ctx = canvas1.getContext("2d");


                    ctx.drawImage(image, sourceX,
                        sourceY,
                        sourceWidth,
                        sourceHeight,
                        destX,
                        destY,
                        destWidth,
                        destHeight);
                    let image2 = new Image();
                    image2 = Canvas2Image.convertToPNG(canvas1);
                    let image2Data = image2.src;
                    doc.addImage(image2Data, 'PNG', 12, 10);
                    croppingYPosition += destHeight;
                }
                const d = new Date().toISOString().slice(0, 19).replace(/-/g, "");
                let filename = 'report_' + d + '.pdf';
                doc.save(filename);
                //$(".print-text-blod").hide()
            };
            image.src = Canvas2Image.convertToPNG(canvas).src;
        })
            .then(() => { this.setState({ isDownLoadPdf: false }) })
    }

    editString(driver_no) {
        let str = '';
        if (driver_no != "") {
            str = '(' + driver_no + ')';
        } else {
            str = 'ไม่รูดบัตร';
        }
        return str;

    }

    handleChangeIsElapseTimeOver = (event) => {

        const target = event.target.checked;
        // const value = target.type === 'checkbox' ? target.checked : target.value;
        console.log(target)
        if (target) {
            this.setState({
                isElapseTimeOver: 4,
                isElapseTimeFlag: target
            });
        } else {
            this.setState({
                isElapseTimeOver: 0,
                isElapseTimeFlag: target
            });
        }

        // const name = target.name;

    }

    render() {
        const { t, onClickBackToReportPortal } = this.props;
        const {
            isClickLoadReport,
            device_no,
            symbolId,
            symbolColor,
            isFullScreen,
            isDownLoadPdf,
            deviceAndGroupList,
            isMobile
        } = this.state;
        // let dataLoop;
        // const dataList = map(deviceAndGroupList, (dataEach, key) => {
        //     dataLoop = {
        //         value: dataEach,
        //         label: dataEach.name
        //     };
        //     return dataLoop;
        // });
        let dataList = [{value:"",label:"-- ทั้งหมด --"}]
        deviceAndGroupList.map((dataEach, key) =>{
            dataList.push({value: dataEach,label: dataEach.name})
        })
        console.log('isElapseTimeOver', this.state.isElapseTimeOver)
        const stylePdf = isDownLoadPdf ? '800px' : '100%';
        return (
            <div className="gray-panel" >


                <div className="col-md-8">
                    <h5 style={{ paddingLeft: '2em', cursor: 'pointer' }} onClick={onClickBackToReportPortal}>
                        <i
                            className="fa fa-arrow-left"
                            aria-hidden="true"
                            style={{ color: 'rgb(115, 134, 213)' }} />
                        <i className="fas fa-file-contract" style={{ color: '#7386D5', marginLeft: 10, marginRight: 5, cursor: "pointer" }} />{t('รายงานข้อมูล')}
                    </h5>
                </div>
                <hr />
                <h5>
                    <span className="fa-stack fa-lg" style={{ color: 'orange' }}>
                        <i className="fa fa-circle fa-stack-2x" />
                        <i className="fa fa-file-text-o fa-stack-1x" style={{ color: 'white' }} />
                    </span>
                    {t('การรูดบัตร')}
                </h5>
                <div className=" form-inline form-group row">

                    <label >{t('ทะเบียนรถ')}</label>&nbsp;
                    {isMobile && <div className="col-md-12">{'\n'}</div>}
                    <div style={{ width: '140px', fontSize: '13px' }}>
                        <Select
                            // value={selectedGroup}
                            onChange={(data) => this.setState({ selectedDevice: data.value, selectedDeviceName: data.label })}
                            options={dataList}
                            placeholder={`-- ${t('ทั้งหมด')} --`}
                        />
                    </div>
                    &nbsp;&nbsp;
                    {isMobile && <div className="col-md-12">{'\n'}</div>}
                    <label htmlFor="example-text-input" >{t('ระหว่างวันที่')}</label>&nbsp;
                    {isMobile && <div className="col-md-12">{'\n'}</div>}

                            <TimePicker className="timeHistory" onChange={this.handleStartTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('00:00', 'HH:mm')} format={'HH:mm'} />&nbsp;
                        <div className="row">
                                <div className="input-group date" id="datetimepicker1">
                                <DateTimeRange
                                    small={true}
                                    isBack
                                    startDateId="MyDatePicker"
                                    endDateId="your_unique_end_date_id"
                                    onSelectDate={this.setRangeDate.bind(this)} />
                            </div>

                        </div>
                            &nbsp;

                            <TimePicker className="timeHistory" onChange={this.handleEndTimeHistoryChange.bind(this)} minuteStep={10} defaultValue={moment('23:50', 'HH:mm')} format={'HH:mm'} />

                    &nbsp;&nbsp;
                    {isMobile && <div className="col-md-12">{'\n'}</div>}
                    <label >
                        <label className=" col-form-label " style={{ cursor: "pointer" }}>
                            <input
                                type="checkbox"
                                checked={this.state.isElapseTimeFlag}
                                onChange={(e) => { this.handleChangeIsElapseTimeOver(e) }} />
                            {t('เกินกว่า 4 ชั่วโมง')}
                        </label>

                    </label>
                    &nbsp;&nbsp;
                            <label>
                        <label className=" col-form-label " style={{ cursor: "pointer" }}>
                            <input
                                type="checkbox"
                                checked={this.state.isNotScan}
                                onChange={(e) => { this.setState({ isNotScan: e.target.checked }) }} />
                            {t('ไม่ได้รูดบัตร')}
                        </label>

                    </label>


                    &nbsp;&nbsp;
                        <div className="btn-group">
                        <button
                            type="button"
                            className="btn btn-primary btn-report"
                            onClick={(e) => this.btnSearchHistoryClick(e)}
                            data-ext="html">
                            {'ตกลง'}
                        </button>
                        <button type="button" name="dropdown-report" className="btn btn-primary dropdown-toggle" onClick={(e) => this.handleClick(e)}>
                            <span className="caret" />
                        </button>
                        <ul className={`dropdown-menu ${isClickLoadReport}`}>
                            {/* <li onClick={() => this.setState({isClickLoadReport: '', reportType: 'pdf'})} className="item-text"><a><i className="fa fa-fw fa-file-pdf-o" style={{color: 'blue'}}/> รายงานแบบ PDF</a> */}
                            <li onClick={() => this.getReport()} className="item-text">
                                <button className="btn btn-light">
                                    <i className="fa fa-fw fa-file-pdf-o" style={{ color: 'blue' }} />
                                    &nbsp;&nbsp;&nbsp;{t('รายงานแบบ PDF')}
                                </button>
                            </li>

                            <li onClick={() => this.setState({ isClickLoadReport: '', reportType: 'excel' })} className="item-text">
                                <button className="btn btn-light">
                                    <i className="fa fa-fw fa-file-excel-o" style={{ color: 'green' }} />
                                    <ReactToExcel
                                        style={{ borderStyle: '' }}
                                        className="btn btn-light"
                                        table="table-to-excel"
                                        filename="rfid"
                                        sheet="sheet 1"
                                        buttonText={t('รายงานแบบ Excel')}
                                    />
                                </button>
                            </li>
                        </ul>
                    </div>

                </div>

                <hr />
                {
                    this.state.rfidList != null && this.state.rfidList != undefined && this.state.rfidList.length > 0 &&
                    <div>
                        <div id="printableTable" ref={el => (this.printableTable = el)}>
                            <table id='table-to-excel' border='1' style={{ display: 'table', backgroundColor: 'white' }} className="table table-responsive table-bordered table-hover" >
                                <div style={{ display: 'none', fontSize: '18px' }}><b>{t('การรูดบัตร')}</b><br /></div>
                                <div style={{ display: 'none', fontSize: '14px' }}><b>{`${t('ระหว่างวันที่')} ${this.getCurrentDate(startHistoryDate) + "," + this.state.selectHistoryDateRange.startTimeHistory} ${t('ถึง')} ${this.getCurrentDate(endHistoryDate) + "," + this.state.selectHistoryDateRange.endTimeHistory}`}</b><br /></div>
                                <thead>
                                    <tr style={{ height: '40px' }}>
                                        <th >{t('วันที่เริ่ม')}</th>
                                        <th >{t('เวลาเข้า')}</th>
                                        <th style={{ width: '20%' }}>{t('จาก')}</th>
                                        <th style={{ width: '20%' }}>{t('ถึง')}</th>
                                        <th >{t('เวลาออก')}</th>
                                        <th >{t('เวลาเดินทาง')}</th>
                                        <th style={{ width: '20%' }}>Card</th>
                                        <th >{t('ระยะทาง')}</th>
                                    </tr>
                                </thead>

                                {
                                    this.state.rfidList.map((data, key) => {
                                        return (

                                            <tbody>
                                                <tr key={key} style={{ backgroundColor: '#f5f5f5' }}>

                                                    <td colSpan="8"><b>{data.device_no}</b></td>

                                                </tr>

                                                {
                                                    data.details.map((detail, key) => {
                                                        return (
                                                            <tr key={key}>
                                                                <td>{detail.date}</td>
                                                                <td>{detail.start_time}</td>
                                                                <td
                                                                    onClick={() =>
                                                                        this.setState({
                                                                            lat: detail.start_at_latitude,
                                                                            long: detail.start_at_longitude,
                                                                            device_no: detail.device_no,
                                                                            symbolId: detail.symbol_id,
                                                                            symbolColor: detail.symbol_color,
                                                                            isClickRowToShowLocation: true,
                                                                            placeName: detail.start_at_place
                                                                        })}
                                                                    style={{ cursor: 'pointer' }}
                                                                >{detail.start_at_place}</td>
                                                                <td
                                                                    onClick={() =>
                                                                        this.setState({
                                                                            lat: detail.end_at_latitude,
                                                                            long: detail.end_at_longitude,
                                                                            device_no: detail.device_no,
                                                                            symbolId: detail.symbol_id,
                                                                            symbolColor: detail.symbol_color,
                                                                            isClickRowToShowLocation: true,
                                                                            placeName: detail.end_at_place
                                                                        })}
                                                                    style={{ cursor: 'pointer' }}
                                                                >{detail.end_at_place}</td>
                                                                <td>{detail.end_time}</td>
                                                                <td>{detail.elapse}</td>
                                                                {
                                                                    !detail.driver_no &&
                                                                    <td style={{ color: "red" }}>ไม่รูดบัตร</td>
                                                                }
                                                                {
                                                                    detail.driver_no &&
                                                                    <td>{detail.driver_name} {detail.driver_no}</td>
                                                                }
                                                                
                                                                <td>{detail.distance}</td>
                                                            </tr>

                                                        )
                                                    })

                                                }

                                                <tr>
                                                    <td colSpan="4"></td>
                                                    <td ><b>รวม</b></td>
                                                    <td><b>{data.summary.total_elapse}</b></td>
                                                    <td></td>
                                                    <td><b>{data.summary.total_distance}</b></td>
                                                </tr>



                                            </tbody>

                                        )
                                    })
                                }



                            </table>
                        </div>

                        <div className="push-up text-center">
                            <div className="btn-group" role="group" aria-label="Basic example">
                                <button type="button" className="btn btn-light border border-secondary" onClick={() => this.getReport()}>
                                    <i className="fa fa-fw fa-file-pdf-o" style={{ color: 'blue' }} />{t('รายงานแบบ PDF')}
                                </button>
                                <button type="button" className="btn btn-light border border-secondary">
                                    <i className="fa fa-fw fa-file-excel-o" style={{ color: 'green' }} />
                                    <ReactToExcel
                                        style={{ borderStyle: '' }}
                                        className="btn btn-light"
                                        table="table-to-excel"
                                        filename="rfid"
                                        sheet="sheet 1"
                                        buttonText={t('รายงานแบบ Excel')}
                                    />
                                </button>
                            </div>
                        </div>
                        {this.state.isClickRowToShowLocation &&
                            <div className="modal-confirm" style={{ display: 'block', position: 'fixed', top: '-70%' }} >
                                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: isFullScreen ? '100%' : '' }}>
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title custom_align" id="Heading">{this.state.placeName}</h4>
                                            <button
                                                type="button"
                                                className="close"
                                                data-dismiss="modal"
                                                aria-hidden="true"
                                                style={{ padding: '0px', margin: '0px', position: 'inherit' }}
                                                onClick={() => this.setState({ isClickRowToShowLocation: false })} >
                                                <span className="fa fa-times" aria-hidden="true" />
                                            </button>
                                        </div>
                                        <div className="modal-body" id="carAlertRow" >
                                            <MapAlertSummaryReport
                                                index={1}
                                                lat={this.state.lat}
                                                lng={this.state.long}
                                                text={device_no}
                                                symbolId={symbolId}
                                                symbolColor={symbolColor}
                                                handleFullScreenToggle={() => this.handleFullScreenToggle()}
                                                isFullScreen={isFullScreen}
                                            />
                                            <button className="btn btn-primary pull-right" onClick={() => this.setState({ isClickRowToShowLocation: false })}  >{t('ตกลง')}</button>
                                        </div>
                                    </div>
                                    {/* /.modal-content */}
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}

ReportRFID.propTypes = {
    t: PropTypes.func.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    token: PropTypes.string.isRequired,
    onClickBackToReportPortal: PropTypes.func.isRequired
}

export default ReportRFID;



// WEBPACK FOOTER //
// ./src/app/view/components/Report/ReportRFID.js